import { View, LabeledFieldView, createLabeledInputText, createDropdown, addListToDropdown, ButtonView, submitHandler, FocusCycler, ViewCollection, FocusTracker, KeystrokeHandler, Collection, UIModel, } from 'ckeditor5';
export class ConditionFormView extends View {
    constructor(locale) {
        super(locale);
        this.conditionIdInput = this.createIdInput();
        this.conditionTypeDropdown = this.createTypeDropdown();
        this.saveButtonView = this.createButton('Save', 'ck-button-save', 'submit');
        this.cancelButtonView = this.createButton('Cancel', 'ck-button-cancel', 'cancel');
        this.deleteButtonView = this.createButton('Delete', 'ck-button-remove', 'delete');
        this.focusTracker = new FocusTracker();
        this.keystrokes = new KeystrokeHandler();
        this.focusables = new ViewCollection();
        this.focusCycler = new FocusCycler({
            focusables: this.focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: 'shift + tab',
                focusNext: 'tab',
            },
        });
        this.setTemplate({
            tag: 'form',
            attributes: {
                class: ['ck', 'ck-condition-form'],
                tabindex: '-1',
            },
            children: [
                this.conditionIdInput,
                this.conditionTypeDropdown,
                {
                    tag: 'div',
                    attributes: { class: ['ck', 'ck-condition-form__actions'] },
                    children: [this.saveButtonView, this.cancelButtonView, this.deleteButtonView],
                },
            ],
        });
    }
    render() {
        super.render();
        submitHandler({ view: this });
        const childViews = [
            this.conditionIdInput,
            this.conditionTypeDropdown,
            this.saveButtonView,
            this.cancelButtonView,
            this.deleteButtonView,
        ];
        childViews.forEach((view) => {
            this.focusables.add(view);
            this.focusTracker.add(view.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    focus() {
        this.focusCycler.focusFirst();
    }
    get conditionId() {
        var _a;
        return ((_a = this.conditionIdInput.fieldView.element) === null || _a === void 0 ? void 0 : _a.value) || '';
    }
    set conditionId(value) {
        const element = this.conditionIdInput.fieldView.element;
        if (element) {
            element.value = value;
        }
    }
    get conditionType() {
        return this.conditionTypeDropdown.buttonView.label || '';
    }
    set conditionType(value) {
        this.conditionTypeDropdown.buttonView.set({ label: value });
    }
    createIdInput() {
        const labeledInput = new LabeledFieldView(this.locale, createLabeledInputText);
        labeledInput.label = 'Condition ID';
        labeledInput.fieldView.placeholder = 'Enter condition ID';
        return labeledInput;
    }
    createTypeDropdown() {
        const dropdown = createDropdown(this.locale);
        dropdown.buttonView.set({
            label: 'assume',
            withText: true,
        });
        const items = new Collection();
        items.add({ type: 'button', model: new UIModel({ label: 'assume', withText: true }) });
        items.add({ type: 'button', model: new UIModel({ label: 'unless', withText: true }) });
        addListToDropdown(dropdown, items);
        dropdown.on('execute', (evt) => {
            const source = evt.source;
            dropdown.buttonView.set({ label: source.label });
        });
        return dropdown;
    }
    createButton(label, className, eventName) {
        const button = new ButtonView(this.locale);
        button.set({
            label,
            withText: true,
            class: className,
        });
        button.on('execute', () => {
            this.fire(eventName);
        });
        return button;
    }
}
